import script from "./RangeComparison.vue?vue&type=script&setup=true&lang=js"
export * from "./RangeComparison.vue?vue&type=script&setup=true&lang=js"

import "./RangeComparison.vue?vue&type=style&index=0&id=6105b1c3&scoped=true&lang=css"

import exportComponent from "/home/viction/eshopcommand/source/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6105b1c3"]])

export default __exports__